import React from 'react'
import { Container, Form, Row, Col, Button } from 'react-bootstrap'
import './../style.scss'
import { useForm } from '@src/lib/react-hook-form'
import { z } from 'zod'
import { CarService, UserService } from '@src/domain/services'
import { SearchCondition } from '../report.view-model'
import { FaSearch, PiMicrosoftExcelLogoBold } from '@src/lib/react-icons'
import _ from 'lodash'
import { defaultDateTime } from '@src/utils'

interface EmployeeRecordsSaerchBarProps {
  factoryOptions: UserService.FactoriesBo;
  carModelOptions: CarService.CarModelsBo;
  searchCondition: SearchCondition;
  searchOnClick: (condition: SearchCondition) => void;
  downloadOnClick: (condition: SearchCondition) => void;
}

export const EmployeeRecordsSaerchBar: React.FC<EmployeeRecordsSaerchBarProps> = ({factoryOptions, carModelOptions, searchCondition, searchOnClick, downloadOnClick}) => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm<SearchCondition>({
    reValidateMode: 'onSubmit',
    defaultValues: {...searchCondition, ...defaultDateTime},
    rules: z.object({
      factoryUuid: z.string().nonempty({ message: '請選擇廠區' }),
      category: z.string().nonempty({ message: '請選擇類別' }),
      fromDate: z.string().optional(),
      fromTime: z.string().optional(),
      toDate: z.string().optional(),
      toTime: z.string().optional(),
      name: z.string().optional(),
      employeeNo: z.string().optional(),
      carModelUuid: z.string().optional(),
      sfxNo: z.string().optional()
    })
  })

  const handleOnSubmit = (dto: SearchCondition) => {
    searchOnClick(dto)
  }

  const handleOnDownload =(dto: SearchCondition) => {
    downloadOnClick(dto)
  }

  const handleTextOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setValue(name, value.toUpperCase(), { shouldValidate: true })
  }

  return (
    <div className='search-bar-wrap'>
      <Container className='employee-search-bar'>
        <Form onSubmit={handleSubmit(handleOnSubmit)}>
          <Row className='mb-3'>
            <Form.Group as={Col}>
              <Form.Label>廠區</Form.Label>
              <Form.Select {...register('factoryUuid')}>
                <option value=''>請選擇廠區</option>
                {
                  factoryOptions
                    .filter(o => o.code !== 'ALL')
                    .map(option => <option key={option.uuid} value={option.uuid}>{`${option.code}-${option.description}`}</option>)
                }
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>類別</Form.Label>
              <Form.Select {...register('category')}>
                <option value='moving'>移車</option>
                <option value='assembly'>組裝</option>
                <option value='quality'>品檢</option>
                <option value='repair'>修復</option>
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>起</Form.Label>
              <Form.Group as={Col} className='datetime-wrap'>
                <div className='d-flex'>
                  <Form.Control className='col date' type='date' {...register('fromDate')} />
                  <Form.Control className='col time' type='time' {...register('fromTime')} />
                </div>
              </Form.Group>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>訖</Form.Label>
              <Form.Group as={Col} className='datetime-wrap'>
                <div className='d-flex'>
                <Form.Control className='col date' type='date'  {...register('toDate')}/>
                <Form.Control className='col time' type='time' {...register('toTime')} />
                </div>
              </Form.Group>
            </Form.Group>
          </Row>
          <Row className='mb-3'>
            <Form.Group as={Col}>
              <Form.Label>員工姓名</Form.Label>
              <Form.Control {...register('name')} />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>員工編號</Form.Label>
              <Form.Control {...register('employeeNo')} />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>車種</Form.Label>
              <Form.Select {...register('carModelUuid')}>
                <option value=''>請選擇車種</option>
                {
                  carModelOptions.map(option => <option key={option.uuid} value={option.uuid}>{`${option.description}`}</option>)
                }
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>SFX NO</Form.Label>
              <Form.Control {...register('sfxNo')} onChange={handleTextOnChange} />
            </Form.Group>
          </Row>
          <div className='d-flex gap-2 btn-row'>
            <div className='error-div'>{_(errors).pickBy(v => !_.isEmpty(v)).mapValues(v => v.message).map().join('、')}</div>
            <Button variant='primary' type='submit'>
              <FaSearch />
              查詢
            </Button>
            <Button variant='success' onClick={handleSubmit(handleOnDownload)}>
              <PiMicrosoftExcelLogoBold />
              下載
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  )
}
